import type { ZudokuConfig } from "zudoku";
import { apis, navigation, plugins, site, theme } from "./zudoku-config";

const { footer } = site

const config: ZudokuConfig = {
  metadata: {
    title: "EMTECH Developer Portal",
    favicon: "https://emtech.com/favicon.png",
  },
  site: {
    logo: {
      src: { light: "/emtech-logo-light.svg", dark: "/emtech-logo-dark.svg" },
      alt: "EMTECH",
      width: "130px",
    },
    showPoweredBy: false,
    footer
  },
  docs: {
    defaultOptions: {
      showLastModified: false
    }
  },
  theme,
  navigation,
  apis,
  plugins
};

export default config;
